module.exports = __webpack_public_path__ + "img/gz_code.7f295af4.png";